import { css } from 'styled-components';

// System font stack only — no web fonts. See --font-sans / --font-mono in variables.js.
const Fonts = css``;

export default Fonts;
